import React from "react";
import { motion } from "framer-motion";
import { Mountain, ArrowRightLeft, Plane, KeyRound, Briefcase, Palmtree, ArrowUpRight } from "lucide-react";
import { buildWhatsAppUrl } from "@/lib/constants";

const SERVICES = [
  { icon: Mountain, title: "Outstation Cabs", desc: "Multi-day trips to hill stations, religious sites and weekend getaways." },
  { icon: ArrowRightLeft, title: "One Way Taxi", desc: "Pay one side only. Affordable intercity drops with no return charges." },
  { icon: Plane, title: "Airport Pickup & Drop", desc: "Punctual pickups and drops at every major Indian airport." },
  { icon: KeyRound, title: "Self Drive Cars", desc: "Hatchbacks, sedans & SUVs on flexible hourly and daily plans." },
  { icon: Briefcase, title: "Corporate Travel", desc: "Monthly billing, dedicated cabs and priority drivers for business clients." },
  { icon: Palmtree, title: "Holiday Packages", desc: "Curated multi-city tours with cab, hotel and itinerary handled end-to-end." },
];

const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="relative py-20 lg:py-28 bg-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-2xl">
          <div className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#19A8E8]">Our Services</div>
          <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-[#0F172A] tracking-tight leading-tight">
            One platform. <span className="text-[#19A8E8]">Every kind of ride.</span>
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.a
                key={s.title}
                href={buildWhatsAppUrl(`Hi Cabsab.com, I'm interested in *${s.title}*. Please share details.`)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`service-card-${s.title.replace(/\s+/g, "-").toLowerCase()}`}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
                className="group relative bg-white border border-slate-200 rounded-2xl p-6 lg:p-7 hover:shadow-[0_12px_30px_rgba(15,23,42,0.08)] hover:border-[#19A8E8]/40 hover:-translate-y-1 transition-all"
              >
                <div className="h-12 w-12 rounded-xl bg-[#19A8E8]/10 flex items-center justify-center group-hover:bg-[#19A8E8] transition-colors">
                  <Icon className="h-5 w-5 text-[#19A8E8] group-hover:text-white transition-colors" />
                </div>
                <h3 className="mt-5 font-display font-semibold text-lg text-[#0F172A]">{s.title}</h3>
                <p className="mt-2 text-sm text-[#64748B] leading-relaxed">{s.desc}</p>
                <div className="absolute bottom-5 right-5 h-9 w-9 rounded-full bg-[#F8FAFC] border border-slate-200 text-[#19A8E8] flex items-center justify-center transition-all group-hover:bg-[#19A8E8] group-hover:text-white group-hover:border-[#19A8E8]">
                  <ArrowUpRight className="h-4 w-4" />
                </div>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
